import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { t } from '../../../../../modules/infra/i18n';

import Icon, { GLYPHS } from '../../../../common/icon';
import { ELIGIBILITY_STEP_STATUS } from '../constants';
import { statusClassName } from '../utils';

const getEligibilityStatusDescription = (status, isAutoPayoutPaused, isAutoPayoutEnabled) => {
  switch (status) {
    case ELIGIBILITY_STEP_STATUS.CRITICAL_REQUIRED:
      return t('settings:auto_payout.eligibility.critical_required');
    case ELIGIBILITY_STEP_STATUS.REQUIRED:
      return isAutoPayoutPaused 
        ? t('settings:auto_payout.eligibility.required_paused')
        : t('settings:auto_payout.eligibility.required_prepare');
    case ELIGIBILITY_STEP_STATUS.DONE:
    default:
      return isAutoPayoutEnabled
        ? t('settings:auto_payout.eligibility.done_enabled')
        : t('settings:auto_payout.eligibility.done_available');
  }
};

const AutoPayoutEligibilityStatus = ({ status, isAutoPayoutPaused, isAutoPayoutEnabled }) => (
  <div className={classnames('c-autopayout__status', statusClassName(status))}>
    <div className={classnames('c-autopayout__status-icon', statusClassName(status))}>
      <Icon
        glyph={GLYPHS.exclamation}
        display-if={status === ELIGIBILITY_STEP_STATUS.REQUIRED}
      />
      <span display-if={status !== ELIGIBILITY_STEP_STATUS.REQUIRED}>i</span>
    </div>
    <span>{getEligibilityStatusDescription(status, isAutoPayoutPaused, isAutoPayoutEnabled)}</span>
  </div>
);

AutoPayoutEligibilityStatus.propTypes = {
  status: PropTypes.oneOf(Object.values(ELIGIBILITY_STEP_STATUS)).isRequired,
  isAutoPayoutPaused: PropTypes.bool.isRequired,
  isAutoPayoutEnabled: PropTypes.bool.isRequired,
};

export default AutoPayoutEligibilityStatus;
